import { render, staticRenderFns } from "./b-select.vue?vue&type=template&id=522f857f&scoped=true&fluid=true&"
import script from "./b-select.vue?vue&type=script&lang=js&"
export * from "./b-select.vue?vue&type=script&lang=js&"
import style0 from "./b-select.vue?vue&type=style&index=0&id=522f857f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522f857f",
  null
  
)

export default component.exports